export default __webpack_public_path__ + "static/media/view.c07bbcb4.svg";